<ul>
  <li><a class="{{current == 1 ? 'disabled': ''}}" href="javascript:void(0);" data-index="1" sk-event.click="{{current == 1 ? 'nothing()': 'tipsShow()'}}">«</a></li>
  <li><a class="{{current == 1 ? 'disabled': ''}}" href="javascript:void(0);" data-index="{{current - 1}}" sk-event.click="{{current == 1 ? 'nothing()': 'tipsShow()'}}">‹</a></li>
   {{if current > 3 && pageNum > 5}}
      <li><a>···</a></li>
   {{/if}}
  {{each pageIndexListCurrent}}
     <li><a href="javascript:void(0);" data-index="{{$value}}" sk-event.click="tipsShow()" class="{{$value == current? 'active':''}}">{{$value}}</a></li>
  {{/each}}
  {{if (current < pageNum-2) && pageNum > 5}}
    <li><a>···</a></li>
  {{/if}}
  <li><a class="{{current == pageNum ? 'disabled': ''}}" href="javascript:void(0);" data-index="{{current + 1}}" sk-event.click="{{current == pageNum ? 'nothing()': 'tipsShow()'}}">›</a></li>
  <li><a class="{{current == pageNum ? 'disabled': ''}}" href="javascript:void(0);" data-index="{{pageNum}}" sk-event.click="{{current == pageNum ? 'nothing()': 'tipsShow()'}}">»</a></li>
</ul>